export default __webpack_public_path__ + "static/images-01-1404fc8910f8bab1a8b9e558b8ac2598.png";